export default __webpack_public_path__ + "static/media/img4.1dbb1af9.png";